module.exports = __webpack_public_path__ + "static/img/SAD200-banner.047bc15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type2-1/SAD200-banner.png
// module id = PhCy
// module chunks = 0